import useI18n from '@/shared/hooks/useI18n'
import { DataBlock } from '@/common'
import { useMemo } from 'react'
import ReactCountryFlag from 'react-country-flag'
import cx from 'classnames'
import { OperatorIdLabel } from '@/components/OperatorIdLabel'

export default function OrganizationInfoData({
  name,
  businessRegistrationNumber,
  hasCertificate,
  onClickCertificate,
  doesOrganizationRequiresLocalAddress,
  localName,
  placeOfRegistration
}: {
  name: string
  businessRegistrationNumber: string
  hasCertificate: boolean
  onClickCertificate: () => void
  doesOrganizationRequiresLocalAddress: boolean
  localName: string
  placeOfRegistration: string
}) {
  const { t } = useI18n()

  const nameLabel = useMemo(() => {
    return doesOrganizationRequiresLocalAddress ? (
      <>
        {t('settings:organizationDetails.organizationInfo.fields.name')}
        <ReactCountryFlag countryCode={placeOfRegistration} svg />
      </>
    ) : (
      t('settings:organizationDetails.organizationInfo.fields.name')
    )
  }, [doesOrganizationRequiresLocalAddress, placeOfRegistration, t])

  return (
    <div
      className={cx(
        'grid grid-cols-3 gap-4',
        doesOrganizationRequiresLocalAddress && 'grid-cols-4'
      )}
    >
      <DataBlock label={nameLabel} data={doesOrganizationRequiresLocalAddress ? localName : name} />
      {doesOrganizationRequiresLocalAddress && (
        <DataBlock
          label={
            <>
              {t('settings:organizationDetails.organizationInfo.fields.name')}
              <ReactCountryFlag countryCode={'gb'} svg />
            </>
          }
          data={name}
        />
      )}
      <DataBlock
        label={<OperatorIdLabel countryCode={placeOfRegistration} />}
        data={businessRegistrationNumber || '-'}
      />
      {hasCertificate ? (
        <div onClick={onClickCertificate} className="cursor-pointer">
          <DataBlock
            label={t('settings:organizationDetails.organizationInfo.fields.businessCertificate')}
            data={t('settings:organizationDetails.organizationInfo.fields.viewCertificate')}
            variant="info"
          />
        </div>
      ) : (
        <DataBlock
          label={t('settings:organizationDetails.organizationInfo.fields.businessCertificate')}
          data="-"
        />
      )}
    </div>
  )
}
